import { Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Instagram, Linkedin } from "lucide-react";
import JoinNowButton from "@/components/landing/JoinNowButton";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

const SiteNav = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-background/80 backdrop-blur-md border-b container flex items-center justify-between py-6">
      <div className="flex items-center gap-4">
        <div className="md:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" aria-label="Open menu">
                <Menu className="h-6 w-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="w-80">
              <div className="flex flex-col justify-between h-full pt-8 pb-6 pl-6">
                <div className="space-y-8">
                  <div className="space-y-3">
                    <Link 
                      to="/" 
                      className="text-lg font-medium hover:text-primary transition-colors py-2 block"
                      onClick={() => setOpen(false)}
                    >
                      Influencers
                    </Link>
                    <Button
                      size="sm"
                      variant="hero"
                      className="w-full"
                      onClick={() => {
                        setOpen(false);
                        window.location.href = '/creatorsignup';
                      }}
                    >
                      Influencer Join Now
                    </Button>
                  </div>
                  
                  <div className="space-y-3">
                    <Link 
                      to="/brands" 
                      className="text-lg font-medium hover:text-primary transition-colors py-2 block"
                      onClick={() => setOpen(false)}
                    >
                      Brands
                    </Link>
                    <Button
                      size="sm"
                      variant="hero"
                      className="w-full"
                      onClick={() => {
                        setOpen(false);
                        window.location.href = '/brandsignup';
                      }}
                    >
                      Brands Join Now
                    </Button>
                  </div>

                  <div>
                    <Link 
                      to="/faqs" 
                      className="text-lg font-medium hover:text-primary transition-colors py-2 block"
                      onClick={() => setOpen(false)}
                    >
                      Frequently Asked Questions
                    </Link>
                  </div>
                </div>

                <div className="border-t pt-6 space-y-4">
                  <Link 
                    to="/legal" 
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors block"
                    onClick={() => setOpen(false)}
                  >
                    Legal
                  </Link>
                  <div className="flex items-center gap-4">
                    <a
                      href="https://www.instagram.com/trycloutfit/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Instagram: @trycloutfit"
                      className="text-muted-foreground hover:text-foreground transition"
                    >
                      <Instagram size={24} />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/cloutfit-ai"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="LinkedIn: Cloutfit.ai"
                      className="text-muted-foreground hover:text-foreground transition"
                    >
                      <Linkedin size={24} />
                    </a>
                  </div>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
        
        <Link
          to="/"
          className="hidden md:block font-roxborough rounded-full bg-foreground text-background px-5 py-2 font-medium tracking-tight shadow-elegant hover:opacity-90 transition"
          aria-label="Cloutfit.ai home"
        >
          Cloutfit.ai
        </Link>
      </div>
      
      <div className="hidden md:flex items-center gap-8">
        <div className="flex items-center gap-6 text-sm">
          <Link 
            to="/" 
            className="font-medium hover:text-primary transition-colors"
          >
            Influencers
          </Link>
          <Link 
            to="/brands" 
            className="font-medium hover:text-primary transition-colors"
          >
            Brands
          </Link>
        </div>
        <JoinNowButton />
      </div>
      
      <div className="md:hidden">
        <JoinNowButton />
      </div>
    </nav>
  );
};

export default SiteNav;
